module.exports = __webpack_public_path__ + "img/2024517-num3.0274466.svg";